import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {
  ActionIconContainer,
  AddFormButton,
} from "../../../shared/components/TableElements";

/**
 * lineItems: [{ name, amount, detail? }]
 * Amount + detail are stacked on the right side of each row.
 */
const ReactivateSubscriptionModal = ({
  show,
  onHide,
  lineItems = [],
  monthlyTotal,
  inputDuration,
  onConfirm,
  loading,
  error,
}) => {
  const { t } = useTranslation("common");

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header>
        <h4>{t("reactivate_subscription")}</h4>
        <div className="d-flex justify-content-end">
          <ActionIconContainer onClick={onHide}>
            <i className="fi fi-rr-cross-small" />
          </ActionIconContainer>
        </div>
      </Modal.Header>

      <Modal.Body>
        <IntroText>{t("reactivate_subscription_message")}</IntroText>

        <BreakdownTable>
          {lineItems.map((item, idx) => (
            <BreakdownRow key={idx}>
              <ItemName>{item.name}</ItemName>
              <ItemRight>
                <ItemAmount>{item.amount}</ItemAmount>
                {item.detail && <ItemDetail>{item.detail}</ItemDetail>}
              </ItemRight>
            </BreakdownRow>
          ))}

          <TotalRow>
            <TotalLabel>{inputDuration === 2 ? t("yearly_total") : t("monthly_total_sm")}</TotalLabel>
            <TotalAmount>{monthlyTotal}</TotalAmount>
          </TotalRow>
        </BreakdownTable>

        {error && <ErrorText>{error}</ErrorText>}
      </Modal.Body>

      <Modal.Footer>
        <AddFormButton onClick={onConfirm} disabled={loading}>
          {loading ? t("reactivating") : t("reactivate_subscription")}
        </AddFormButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ReactivateSubscriptionModal;

// ── Styled components ─────────────────────────────────────────────────────────

const IntroText = styled.p`
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 16px;
  line-height: 1.6;
`;

const BreakdownTable = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
`;

const BreakdownRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
`;

const ItemName = styled.span`
  font-size: 13px;
  color: #374151;
`;

const ItemRight = styled.div`
  text-align: right;
`;

const ItemAmount = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #111827;
`;

const ItemDetail = styled.div`
  font-size: 11px;
  color: #9ca3af;
  margin-top: 2px;
`;

const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f9fafb;
`;

const TotalLabel = styled.span`
  font-size: 13px;
  color: #374151;
`;

const TotalAmount = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: #111827;
`;

const ErrorText = styled.div`
  font-size: 13px;
  color: #ef4444;
  margin-top: 10px;
`;
